import { AnimatePresence, motion, Variants } from "framer-motion";
import classNames from "classnames";
import { Props as ShapeProps } from "../Shape";
import { theming } from "../theming";
import Portal from "util/Portal";
import useEscapeHandler from "./useEscapeHandler";
import CloseButton from "./CloseButton";
import {
  useParentVariants,
  childrenVariants,
  NeededMeasurements,
} from "./variants";

interface Props {
  measurements: NeededMeasurements;
  open: boolean;
  onRequestClose?: () => void;
  fullScreenOverlay: NonNullable<ShapeProps["fullScreenOverlay"]>;
  theme: typeof theming[keyof typeof theming];
  noAnimation?: boolean;
}

export default function ShapeFullScreenOverlay({
  measurements,
  open,
  onRequestClose,
  fullScreenOverlay,
  theme,
  noAnimation = false,
}: Props) {
  const ref = useEscapeHandler(open, onRequestClose);
  const parentVariants = useParentVariants(measurements);

  return (
    <Portal>
      <AnimatePresence>
        <motion.div
          ref={ref}
          tabIndex={-1}
          className={classNames(
            "fixed inset-0 z-30",
            theme.solid.bg,
            theme.solid.text
          )}
          animate={open ? "open" : "closed"}
          initial="closed"
          variants={noAnimation ? undefined : parentVariants}
        >
          {onRequestClose && <CloseButton onRequestClose={onRequestClose} />}

          {fullScreenOverlay({ childrenVariants })}
        </motion.div>
      </AnimatePresence>
    </Portal>
  );
}
